module.exports = __webpack_public_path__ + "static/assets/41ebcde49032d543af1a2c843a725834.mp3";